import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const RoomFull = () => {
  const location = useLocation();
  const error = location.state?.error;
  const navigate = useNavigate();
  useEffect(() => {
    if (error) {
      toast.error(error, {
        position: "top-right",
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  }, [error]);

  const handleNavigate = () => {
    sessionStorage.removeItem("currUrlPath");
    sessionStorage.removeItem("peerId");
    navigate("/lobby", { replace: true });
  };

  if (error) {
    return (
      <div className=" main-box">
        <div className="waiting-loader">
          <h2 style={{ padding: "10px 35px" }}>{error}</h2>
          <button className="leave-btn" onClick={handleNavigate}>Return to lobby</button>
        </div>
      </div>
    );
  }
};

export default RoomFull;
